import { SignUpResource } from "@clerk/types";
import { AUTH_ERRORS, USE_LONG_MESSAGE_FOR_ERROR_CODES } from "./authConstants";
import { isClerkAPIResponseError } from "@clerk/nextjs/errors";

export function getErrorMessage(
  error: any,
  fallbackMessage: string = AUTH_ERRORS.GENERAL_ERROR
): string {
  if (
    isClerkAPIResponseError(error) &&
    USE_LONG_MESSAGE_FOR_ERROR_CODES.includes(error.errors[0].code)
  ) {
    return error.errors[0].longMessage || fallbackMessage;
  }

  return fallbackMessage;
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function shouldShowVerification(signUp: SignUpResource | null): boolean {
  if (!signUp) return false;

  return (
    signUp.status === "missing_requirements" &&
    signUp.verifications?.emailAddress?.status === "unverified"
  );
}

export function isSignUpComplete(signUp: SignUpResource | null): boolean {
  if (!signUp) return false;
  return signUp.status === "complete";
}

export function formatVerificationCode(code: string): string {
  // Remove non-digits and limit to 6 characters
  return code.replace(/\D/g, "").slice(0, 6);
}
